import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import CardService from '../services/CardService';
import ProfileService from '../services/ProfileService';
class OrderPlasticConfirmationDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.profileService = new ProfileService();
        this.state = {
            plasticCard: true,
        };
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton
                    label={t('cards.orderCardConfirmationOrderPlasticButton')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                />
            </div>
        );
    }
    handleValidForm() {
        this.props.handleFormSubmit();
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('cards.confirmationOrderingCard')}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    initBeforeSetElement() {
        const {t} = this.props;
        this.profileService
            .get()
            .then((profile) => {
                this.setState({profile}, () => this.setElement());
            })
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.profile'));
            });
    }
    setElement() {
        this.initAfterSetElement();
    }

    renderDetails() {
        const {t} = this.props;

        return (
            <div>
                <div className='row'>
                    <label id={`order-plastic-confirmation-label-id`} className='col-12 title-label'>
                        {t('cards.confirmationOrderingCardDesc')}
                    </label>
                </div>
                <InputCheckboxComponent
                    id={'plasticCardOrderDialog'}
                    name='plasticCardOrder'
                    label={t('order-card.shortPlasticLabel')}
                    labelOnRight
                    value={this.state.plasticCard}
                    validator={this.validator}
                    onChange={this.handleChange}
                    viewMode={'EDIT'}
                    disabled
                    colClass='col-12'
                    labelClassName='p-checkbox-label disabled-label'
                />
                {/* <div className='col-12'>
                    <label
                        id={`order-plastic-confirmation-price-label-id`}
                        className='colorfull-label'
                        style={{backgroundColor: '#FD6F1F'}}
                    >
                        {this.props.orderPlasticCardPrice} {t('currency.pln')}/{t('details.item')}
                    </label>
                </div> */}
            </div>
        );
    }
}

OrderPlasticConfirmationDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

OrderPlasticConfirmationDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    cardNumbers: PropTypes.array,
    handleFormSubmit: PropTypes.func,
};

export default withTranslation()(OrderPlasticConfirmationDialog);
